module.exports = __webpack_public_path__ + "img/org-example.cd79cc4a.png";